<template>
    <m-dialog :show="show" @update:show="s => $emit('update:show', s)" @close="cleanUrl()"
              heading="Reset your password?" width="280px">
        <div class="label">Password</div>
        <m-password class="w-full" v-model="password" :newpassword="true"></m-password>
        <div class="text-error-500" v-if="$v.password.$error">Password is required</div>
        <div class="label">Confirm password</div>
        <m-password class="w-full" v-model="confirm" :newpassword="true"></m-password>
        <div class="text-error-500" v-if="$v.confirm.$error">Confirm password must match password</div>
        <div class="text-error-500 text-sm" v-if="errorMessage">{{ errorMessage }}</div>
        <template slot="footer">
            <div class="btn btn-error" @click="$emit('update:show', false)">Cancel</div>
            <div class="btn btn-primary" @click="submit()">Reset</div>
        </template>
    </m-dialog>
</template>
<script>
// Reset password, after forgot password was selected from the login screen
import Ajax from '../js/ajax.js'
import {required, sameAs} from 'vuelidate/lib/validators'
import Share from '@/share.js'
import share from '../share';

function cleanUrl() {
    if (window.history && window.history.replaceState) {
        window.history.replaceState({}, document.title, '/');
    }
}

const loginStatusString = {
  0: "Token expired.",
  1: "Password must contain at least 5 characters, 1 uppercase letter, 1 lowercase letter, 1 number and not been used before.",
  2: "",
}

export default {
    props: {
        show: Boolean,
        token: String
    },
    data() {
        return {
            password: '',
            confirm: '',
            errorMessage: ''
        }
    },
    validations: {
        password: {required},
        confirm: {required, sameAs: sameAs('password')}
    },
    methods: {
        cleanUrl() {
            cleanUrl()
        },
        submit() {
            cleanUrl()

            this.$v.$touch()
            if (this.$v.$error) {
                return
            }

            share.showLoader()
            Ajax.post('/auth/resetpassword', {
                token: this.token,
                password: this.password,
            }).then(data => {
                // Data is true if the password was changed successfully
                if (data == 2) {
                    Share.showSnack('Your password has been changed successfully.')
                    this.$emit('update:show', false)
                    cleanUrl()
                    return
                }
                
                this.errorMessage = loginStatusString[data] ?? "Could not update your password."
                share.hideLoader()
            }).catch((e) => {
                Share.showSnack('We could not change your password at this time. Please try again')
                this.$emit('update:show', false)
                cleanUrl()
                share.hideLoader()
                Sentry.captureMessage(e);

            })

        },
    }
}
</script>


